import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Button, Collapse, Divider, Stack } from '@mui/material'
import { useState } from 'react'

export type ShowHideWrapperProps = {
  children: React.ReactNode
  hideLabel?: string
  showLabel?: string
}
export const ShowHideWrapper = (props: ShowHideWrapperProps) => {
  const [visible, setVisible] = useState(false)
  const showLabel = props.showLabel || 'More Metadata'
  const hideLabel = props.hideLabel || 'Less Metadata'

  return (
    <>
      <Stack direction="row" spacing={2} sx={{ justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          onClick={() => setVisible(!visible)}
          endIcon={visible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          aria-expanded={visible}
        >
          {visible ? hideLabel : showLabel}
        </Button>
      </Stack>
      <Collapse in={visible} timeout={500}>
        <Divider sx={{ mt: 2, mb: 2 }} />
        {props.children}
      </Collapse>
    </>
  )
}
